import { profileService } from 'config/api';
import { addNotification } from 'shell/actions';
import actionTypes from './actionTypes';

const MIN_NOTES_SEARCH_SYMBOLS = 3;

export const fetchClientNotes = (customerId, query) => async (dispatch) => {
  if (query && query.length < MIN_NOTES_SEARCH_SYMBOLS) {
    return dispatch({ type: actionTypes.GET_CLIENT_NOTES_SUCCESS, payload: [] });
  }

  dispatch({
    type: actionTypes.GET_CLIENT_NOTES_LOADING,
  });

  try {
    const params = {};
    if (query) {
      params.q = query;
    }
    const res = await profileService.get(`/customers/${customerId}/notes`, {
      params,
    });

    dispatch({ type: actionTypes.GET_CLIENT_NOTES_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({
      type: actionTypes.GET_CLIENT_NOTES_ERROR,
      payload:
        error.response?.data?.message || error?.message || 'Not able to get client notes list, please try again later.',
    });
  }
};

export const deleteClientsNotes = (noteId, customerId) => async (dispatch) => {
  dispatch({
    type: actionTypes.DELETE_CLIENT_NOTES_LOADING,
  });

  try {
    await profileService.delete(`/customers/${customerId}/notes/${noteId}`);

    dispatch({ type: actionTypes.DELETE_CLIENT_NOTES_SUCCESS, payload: noteId });
    dispatch(
      addNotification({
        id: `delete-${Date.now()}`,
        message: `Note successfully removed`,
        type: 'success',
      }),
    );
  } catch (error) {
    dispatch({
      type: actionTypes.DELETE_CLIENT_NOTES_ERROR,
      payload:
        error.response?.data?.message ||
        error?.message ||
        'Not able to delete client notes list, please try again later.',
    });
  }
};

export const notesFilterBy = (filter) => ({
  type: actionTypes.NOTES_FILTER_BY,
  payload: filter,
});

export const createClientNote = (note, customerId) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_CLIENT_NOTE_LOADING });

  try {
    const res = await profileService.post(`/customers/${customerId}/notes`, note);

    dispatch({ type: actionTypes.CREATE_CLIENT_NOTE_SUCCESS, payload: res.data });
    return 'success';
  } catch (err) {
    const error = err.response?.data?.message || err?.message || 'Note creation error';
    dispatch({ type: actionTypes.CREATE_CLIENT_NOTE_ERROR, payload: error });
    return 'error';
  }
};

export const editClientNote = (note, customerId, noteId) => async (dispatch) => {
  dispatch({ type: actionTypes.EDIT_CLIENT_NOTE_LOADING });

  try {
    const res = await profileService.put(`/customers/${customerId}/notes/${noteId}`, note);

    dispatch({ type: actionTypes.EDIT_CLIENT_NOTE_SUCCESS, payload: res.data });
    return 'success';
  } catch (err) {
    const error = err.response?.data?.message || err?.message || 'Note edition error';
    dispatch({ type: actionTypes.EDIT_CLIENT_NOTE_ERROR, payload: error });
    return 'error';
  }
};

export const fetchNoteDetails = (customerId, noteId) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_CLIENT_NOTE_DETAILS_LOADING });

  try {
    const res = await profileService.get(`/customers/${customerId}/notes/${noteId}`);

    dispatch({ type: actionTypes.GET_CLIENT_NOTE_DETAILS_SUCCESS, payload: res.data });
    return 'success';
  } catch (err) {
    const error = err.response?.data?.message || err?.message || 'Note details error';
    dispatch({ type: actionTypes.GET_CLIENT_NOTE_DETAILS_ERROR, payload: error });
    return 'error';
  }
};
